/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VolumeSettings } from '../models/VolumeSettings';

export class RestoreInstanceVolumeInput {
  /**
  * Cloud-provider-assigned ID of the volume to restore.
  */
  'providerVolumeId': string;
  /**
  * Optional description.
  */
  'description'?: string;
  /**
  * Tags to apply to the restored volume as key-value pairs, where key and value are both strings.  **Example:** `{\"primary\": \"\"}` 
  */
  'tags'?: { [key: string]: string; };
  /**
  * ARN of the KMS key for encrypting the restored volume.
  */
  'volumeEncryptionKeyId': string;
  'volumeSettings': VolumeSettings;
  /**
  * Optional encryption key ID to use for the restore process
  */
  'encryptionKeyId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerVolumeId",
      "baseName": "providerVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "volumeEncryptionKeyId",
      "baseName": "volumeEncryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeSettings",
      "baseName": "volumeSettings",
      "type": "VolumeSettings",
      "format": ""
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreInstanceVolumeInput.attributeTypeMap;
  }

  public constructor() {
  }
}

